import { useState, useEffect } from "react";
import { teamMembersAPI, TeamMemberDTO } from "../../data/api/teamMembersApi";

interface UseTeamMembersReturn {
  teamMembers: TeamMemberDTO[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useTeamMembers = (): UseTeamMembersReturn => {
  const [teamMembers, setTeamMembers] = useState<TeamMemberDTO[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTeamMembers = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await teamMembersAPI.getTeamMembers();
      setTeamMembers(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch team members");
      console.error("Error fetching team members:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  return {
    teamMembers,
    loading,
    error,
    refetch: fetchTeamMembers,
  };
};

